<t-llevo-dialog-header
  dialogTitle="Adicionar usuario"
  mat-dialog-title
></t-llevo-dialog-header>

<mat-dialog-content commonui-loader [appLoader]="loading() ?? false">
  <form [formGroup]="frm" class="formGroup">
    <mat-form-field>
      <mat-label>Nombre</mat-label>
      <input matInput #firstInput formControlName="firstname" />
      @if(firstname.hasError('required')){
      <mat-error>Campo requerido</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Apellidos</mat-label>
      <input matInput formControlName="lastname" />
      @if(lastname.hasError('required')){
      <mat-error>Campo requerido</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Número telefónico</mat-label>
      @if(phone.errors){
      <mat-hint>Formato requerido: 8 números (55125432)</mat-hint>
      }
      <input matInput formControlName="phone" maxlength="8" />
      @if(phone.hasError('required')){
      <mat-error>Campo requerido</mat-error>
      } @else if(phone.hasError('pattern')) {
      <mat-error>Formato requerido: 8 números</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Email</mat-label>
      <input matInput formControlName="email" />
      @if(email.hasError('required')){
      <mat-error>Campo requerido</mat-error>
      } @else if(email.hasError('pattern')){
      <mat-error>Formato de correo incorrecto</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Contraseña</mat-label>
      <mat-hint
        >Formato: La contraseña debe contener una letra en mayúscula, una en
        minúscula, un número y un carácter especial</mat-hint
      >
      <input
        matInput
        [type]="passwordControlHide ? 'password' : 'text'"
        formControlName="password"
      />
      <button
        mat-icon-button
        matSuffix
        (click)="passwordControlHide = !passwordControlHide"
        [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="passwordControlHide"
        type="button"
      >
        <mat-icon
          [svgIcon]="passwordControlHide ? 'eye-off' : 'eye'"
        ></mat-icon>
      </button>
      @if(password.hasError('required')){
      <mat-error>Campo requerido</mat-error>
      } @else if(password.hasError('minlength')){
      <mat-error
        >La contraseña debe contener más de
        {{ password.errors!['minlength']['requiredLength'] }}
        carácteres</mat-error
      >
      } @else if (password.hasError('pattern')) {
      <mat-error
        >La contraseña debe contener una letra en mayúscula, una en minúscula,
        un número y un carácter especial</mat-error
      >
      }
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-flat-button mat-dialog-close>Cancelar</button>
  <button
    class="actionsContainer__submit"
    mat-flat-button
    (click)="onSubmit()"
    [disabled]="loading() ?? false"
    color="accent"
  >
    Guardar
  </button>
</mat-dialog-actions>
